 <!-- HOME ICONE BEGIN-->

 <div class="pull-right icon-bar">
   <a class="active mat-elevation-z8" href="https://api.whatsapp.com/send?phone=59323420092&text=Hola%21%20Quisiera%20m%C3%A1s%20informaci%C3%B3n%20sobre%20los%20seguros%20que%20Chubb%20tiene%20para%20clientes%20Banco%20Guayaquil%20😊." target="_blanc"><span class='icon'></span></a>
 </div>
<!-- HOME ICONE END-->
